import { render, staticRenderFns } from "./ConsignmentCard.vue?vue&type=template&id=02566616&"
import script from "./ConsignmentCard.vue?vue&type=script&lang=js&"
export * from "./ConsignmentCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports